/**
 * The row's note, as every Inbox sheet and row draws it - kept out of
 * InboxPage.tsx so DraftSheets.tsx can use it without importing the page it
 * is rendered by.
 */

/**
 * Claude's words, set apart from the record's: muted and italic, never in the row's own type.
 *
 * Always wraps, whatever the cell around it does - a money row's description
 * cell is one line, and a 500-character note inside it ran straight across
 * the Type and Amount columns. `clamp` on a table or card row: three lines at
 * most, the whole note as the tooltip; a sheet shows it in full.
 */
export function Note({ text, clamp = false, ...rest }: { text: string; clamp?: boolean; 'data-testid'?: string }) {
  return (
    <p
      className={`mt-0.5 whitespace-normal break-words text-xs italic text-muted-foreground${clamp ? ' line-clamp-3' : ''}`}
      title={clamp ? text : undefined}
      {...rest}
    >
      {text}
    </p>
  );
}
